import { render, staticRenderFns } from "./VTdepnoAction.vue?vue&type=template&id=2364dac7&"
import script from "./VTdepnoAction.vue?vue&type=script&lang=js&"
export * from "./VTdepnoAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports